module.exports = __webpack_public_path__ + "static/media/sn-thumb.fb4f102c.png";